import {BaseView} from '../core/view';
import { TrackingUtil } from "../utils/tracking"

let scrollObject = [];

export default BaseView.extend({

    el: '.js-filter-swipy',

    events:{
        'click .js-filter-swipy-arrow-left': 'leftArrowClick',
        'click .js-filter-swipy-arrow-right': 'rightArrowClick',
        'click .js-filter-suggestions-item': 'throwClickEvent'
    },

    initialize: function () {
        if (this.$el.length) {
            let self = this;
            scrollObject['padding-width'] = 13;
            this.updateSwipySettings();

            this.$el.find('.js-filter-swipy-scrolltrick').on('scroll', function (e) {
                scrollObject['scroll-position'] = $(this).scrollLeft();
                self.checkScrollPosition();
            });

            $(window).on('resize', function (e) {
                if ($(this).width() < 992) {
                    self.updateSwipySettings();
                }
            });

            //need a timer to fix scroll width due to safari bug
            setTimeout(function () {
                self.updateSwipySettings()
            }, 500);

            TrackingUtil.throwFilterSuggestionsViewEvent(this.$el.attr('data-ga-action') + "View");
        }
    },

    leftArrowClick: function(){
        this.$el.find('.js-filter-swipy-scrolltrick').animate({scrollLeft: "-=100"}, '200');
    },

    rightArrowClick: function(){
        this.$el.find('.js-filter-swipy-scrolltrick').animate({scrollLeft: "+=100"}, '200');
    },

    throwClickEvent: function(e){
        const action = this.$el.attr('data-ga-action') + "Click";
        const url = e.currentTarget.getAttribute('data-link');
        const filterSuggestionId = e.currentTarget.getAttribute('data-suggestion-id');
        const filterSuggestionType = e.currentTarget.getAttribute('data-suggestion-type');
        TrackingUtil.throwFilterSuggestionsClickEvent(action, url, filterSuggestionId, filterSuggestionType);
    },

    updateScroll: function() {
        scrollObject['scrollcontainer-width'] = this.$el.find('.js-filter-swipy-container').width();
        scrollObject['viewport-width'] = this.$el.width();
        scrollObject['scroll-position'] = this.$el.find('.js-filter-swipy-scrolltrick').scrollLeft();
        scrollObject['left-limit'] = 0 + scrollObject['padding-width'];
        scrollObject['right-limit'] = scrollObject['scrollcontainer-width']-(scrollObject['padding-width']+scrollObject['viewport-width']);
    },

    updateSwipySettings: function() {
        this.updateScroll();
        this.checkScrollPosition();
    },

    checkScrollPosition: function(){
        let viewportWidth = scrollObject['viewport-width'];
        let containerWidth = scrollObject['scrollcontainer-width'];
        if ( viewportWidth >= containerWidth){
            this.hideRightArrow();
            this.hideLeftArrow();
        }else{
            let scrollPos = scrollObject['scroll-position'];
            let leftLim = scrollObject['left-limit'];
            let rightLim = scrollObject['right-limit'];

            if (scrollPos < leftLim){
                this.hideLeftArrow();
            }else{
                this.showLeftArrow();
            }
            if (scrollPos >= rightLim){
                this.hideRightArrow();
            }else{
                this.showRightArrow();
            }
        }
    },

    hideLeftArrow: function(scrollPosition){
        this.$el.addClass('scrollable-list--hide-left-arrow');
    },

    hideRightArrow: function(scrollPosition){
        this.$el.addClass('scrollable-list--hide-right-arrow');
    },

    showLeftArrow: function(scrollPosition){
        this.$el.removeClass('scrollable-list--hide-left-arrow');
    },

    showRightArrow: function(scrollPosition){
        this.$el.removeClass('scrollable-list--hide-right-arrow');
    }

});